import { render, staticRenderFns } from "./SelectPersonStatus.vue?vue&type=template&id=574c94e3&scoped=true&"
import script from "./SelectPersonStatus.vue?vue&type=script&lang=js&"
export * from "./SelectPersonStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c94e3",
  null
  
)

export default component.exports